import React from 'react'
import PropTypes from 'prop-types'
import BoxChart from '../../generals/boxCharts'
import Pie from '../../generals/charts/pie'
import KnobChart from '../../generals/charts/knob'
import VerticalBar from '../../generals/charts/verticalBar'
import stylesCardsInfo from '../../../css/generals/CardsInfo.module.css'
import BatteryChart from '../../generals/charts/battery'
import { ProgressSpinner } from 'primereact/progressspinner'
import DevicesUseTimeChart from './DevicesUseTimeChart'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import ToggleButton from 'react-bootstrap/ToggleButton'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function CardsStatsRealTime ({ stat, funcSokDisk, funcSokRam, funcSokBattery, connections, labelConn, role, deviceUseTime, dates, dateFilter, setDateFilter, id }) {
  const { t } = useTranslation('dashboardDevice')

  return (
        <div className={stylesCardsInfo.cardsContainer}>
          {role?.dashboardDevicePage.diskChartDashboardDevice && <BoxChart
            title={t('cardsStats.title1')}
            icon="fa-solid fa-floppy-disk"
            className={`${stylesCardsInfo.boxChart}`}>
            <div className={stylesCardsInfo.containerBoxChart}>
              <Pie
                type={'individual'}
                //* se agrega validacion para tiempo real para que no se rompar en otros lugares
                realTime={true}
                funcSokDisk={funcSokDisk}
                data={stat}
              />
            </div>
          </BoxChart>}
          {role?.dashboardDevicePage.ramChartDashboardDevice && <BoxChart
            title={t('cardsStats.title2')}
            icon="fa-solid fa-memory"
            className={`${stylesCardsInfo.boxChart}`}
          >
            <div className={stylesCardsInfo.containerBoxChart}>
              <KnobChart
                type="individual"
                size={230}
                //* se agrega validacion para tiempo real para que no se rompar en otros lugares
                realTime={true}
                funcSokRam={funcSokRam}
                data={stat}
              />
            </div>
          </BoxChart>}
          {role?.dashboardDevicePage.battery && <BoxChart
            title={t('cardsStats.title3')}
            icon="fas fa-battery-full"
            className={`${stylesCardsInfo.boxChart}`}
            >
              <div className={stylesCardsInfo.batteryContainer}>
                {/* se armo un componente de bateria para tenerlo separado */}
                <BatteryChart
                  role={role}
                  //* se agrega validacion para tiempo real para que no se rompar en otros lugares
                  realTime={true}
                  funcSokBattery={funcSokBattery}
                  statBattery={stat?.Battery}
                />
              </div>
            </BoxChart>}
            {role?.dashboardDevicePage.connectionsVerticalBar && <BoxChart
              title={t('cardsStats.title4')}
              icon="fa-solid fa-mobile"
              className={`${stylesCardsInfo.boxChart}`}
            >
              {connections === undefined || connections?.error || connections.length === 0
                ? (
                <h5>{t('cardsStats.label1')}</h5>
                  )
                : labelConn
                  ? (<div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          width: '100%',
                          height: 'auto',
                          alignItems: 'center',
                          position: 'relative'
                        }}
                      >
                      {role?.dashboardDevicePage.moreConnectionsButton && <NavLink
                        to={`/mdm/connections-history/${id}`}
                        className={`btn btn-dark ${stylesCardsInfo.navLinkLastLocation}`}
                        type="button"
                        onClick={() => {
                          window.scrollTo({
                            top: 0,
                            behavior: 'smooth'
                          })
                        }}
                      >
                        <i className="pi pi-map-marker" style={{ marginRight: '0.5rem' }}></i>
                        {t('cardsStats.title4')}
                      </NavLink>}
                      <VerticalBar
                        data={labelConn.data}
                        labels={labelConn.labels}
                        backgroundColor={labelConn.backgroundColor}
                        title={t('cardsStats.title4')}
                      />
                  </div>)
                  : (<></>)}
            </BoxChart>}
            {role?.dashboardDevicePage.devicesUseTimeChart && <BoxChart
              title={t('cardsStats.title5')}
              icon="fa-solid fa-mobile"
              className={`${stylesCardsInfo.boxChart}`}
            >
              <ButtonGroup className={stylesCardsInfo.dateFilterContainer}>
                {dates.map((date, index) => (
                  <ToggleButton
                    key={index}
                    id={`date-home-${index}`}
                    type="radio"
                    variant="secondary"
                    name="date-home"
                    value={date.value}
                    checked={date.value === dateFilter}
                    className={stylesCardsInfo.btnDateUseTimeApps}
                    onChange={(e) => setDateFilter(parseInt(e.target.value))}
                  >
                    {date.name}
                  </ToggleButton>
                ))}
              </ButtonGroup>
              {deviceUseTime === undefined
                ? (
                  <ProgressSpinner />
                  )
                : deviceUseTime?.error || deviceUseTime?.useTime === 0
                  ? (
                  <h5>{t('cardsStats.label1')}</h5>
                    )
                  : (<DevicesUseTimeChart
                    data={deviceUseTime}
                    filter={dateFilter}
                  />)}
            </BoxChart>}
        </div>
  )
}

CardsStatsRealTime.propTypes = {
  stat: PropTypes.object,
  funcSokRam: PropTypes.func,
  funcSokDisk: PropTypes.func,
  funcSokBattery: PropTypes.func,
  connections: PropTypes.array,
  labelConn: PropTypes.object,
  role: PropTypes.object,
  deviceUseTime: PropTypes.object,
  dates: PropTypes.array,
  dateFilter: PropTypes.number,
  setDateFilter: PropTypes.func,
  id: PropTypes.number
}
